module.exports = __webpack_public_path__ + "static/img/9.37e6474a.png";